<script>

    export let value = null
    export let label = null

</script>

<div class="field">
    {#if label}
        <label for="" class="label">{ label }</label>
    {/if}
    <div class="control has-icons-left">
        <span class="icon"><i class="fas fa-lock"></i></span>
        <input bind:value={value} type="password" class="input" placeholder="• • • • • • • • •" required />
    </div>
</div>
